<template>
  <div class="rupturas-resumo">

    <!-- ── Linha 1: KPIs financeiros com contagens de SKUs ── -->
    <div class="kpi-row">

      <div class="kpi-card">
        <div class="kpi-accent" style="background:#0ea5e9"></div>
        <div class="kpi-icon-wrap" style="background:#e0f2fe">
          <v-icon color="#0284c7" size="20">mdi-cart-outline</v-icon>
        </div>
        <div class="kpi-body">
          <kpi-tooltip>
            <template v-slot:label>
              <span class="kpi-label">Total Sugerido</span>
            </template>
            Volume bruto de solicitações de reabastecimento via CISS, incluindo sugestões automáticas e produtos adicionados manualmente.
          </kpi-tooltip>
          <span class="kpi-value" style="color:#0284c7">{{ formatCurrency(resumo.total_volume) }}</span>
          <span class="kpi-skus">{{ formatNumber(resumo.qtd_skus_volume) }} SKUs solicitados</span>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-accent" style="background:#94a3b8"></div>
        <div class="kpi-icon-wrap" style="background:#f1f5f9">
          <v-icon color="#64748b" size="20">mdi-minus-circle-outline</v-icon>
        </div>
        <div class="kpi-body">
          <kpi-tooltip>
            <template v-slot:label>
              <span class="kpi-label">Itens Excluídos FL</span>
            </template>
            Produtos classificados como inativos para compra ou com estoque máximo zerado no cadastro, não sendo incluídos no cálculo de ruptura.
          </kpi-tooltip>
          <span class="kpi-value" style="color:#64748b">{{ formatCurrency(resumo.total_excluidos) }}</span>
          <span class="kpi-skus">{{ formatNumber(qtdSkusExcluidos) }} SKUs fora de linha</span>
          <span v-if="percentualExcluidos > 0" class="kpi-percentual kpi-percentual-neutro">
            {{ formatPercent(percentualExcluidos) }} do total
          </span>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-accent" style="background:#023449"></div>
        <div class="kpi-icon-wrap" style="background:#e0f4f8">
          <v-icon color="#023449" size="20">mdi-clipboard-list-outline</v-icon>
        </div>
        <div class="kpi-body">
          <kpi-tooltip>
            <template v-slot:label>
              <span class="kpi-label">Necessidade de abastecimento</span>
            </template>
            Necessidade de abastecimento dos produtos após a exclusão de SKUs fora de linha, utilizada como base para avaliar ruptura ou atendimento completo.
          </kpi-tooltip>
          <span class="kpi-value" style="color:#023449">{{ formatCurrency(resumo.necessidade_real) }}</span>
          <span class="kpi-skus">{{ formatNumber(resumo.qtd_skus_ativos) }} SKUs ativos</span>
          <span v-if="percentualNecessidade > 0" class="kpi-percentual kpi-percentual-info">
            {{ formatPercent(percentualNecessidade) }} do total
          </span>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-accent" style="background:#059669"></div>
        <div class="kpi-icon-wrap" style="background:#d1fae5">
          <v-icon color="#047857" size="20">mdi-check-circle-outline</v-icon>
        </div>
        <div class="kpi-body">
          <kpi-tooltip>
            <template v-slot:label>
              <span class="kpi-label">Total Atendido</span>
            </template>
            Valor efetivamente aprovado e entregue às filiais conforme a necessidade. Representa o reabastecimento que foi concluído com sucesso.
          </kpi-tooltip>
          <span class="kpi-value" style="color:#047857">{{ formatCurrency(resumo.total_atendidos) }}</span>
          <span class="kpi-skus">{{ formatNumber(resumo.qtd_skus_atendidos) }} SKUs atendidos</span>
          <span v-if="percentualAtendido > 0" class="kpi-percentual kpi-percentual-ok">
            {{ formatPercent(percentualAtendido) }} da necessidade
          </span>
        </div>
      </div>

    </div>

    <!-- ── Linha 2: Percentuais principais + Sem Estoque CD ── -->
    <div class="kpi-row">

      <div v-if="false" class="kpi-card kpi-card--pct">
        <div class="kpi-accent" style="background:#ea580c"></div>
        <div class="kpi-icon-wrap kpi-icon-wrap--sm" style="background:#ffedd5">
          <v-icon color="#c2410c" size="18">mdi-percent-outline</v-icon>
        </div>
        <div class="kpi-body">
          <kpi-tooltip icon-size="10">
            <template v-slot:label>
              <span class="kpi-label">% Ruptura (SKUs)</span>
            </template>
            Proporção de produtos que sofreram ruptura (total ou parcial) sobre todos os produtos ativos.
          </kpi-tooltip>
          <span class="kpi-value" style="color:#c2410c">{{ formatPercent(resumo.percentual_ruptura_skus) }}</span>
          <div class="pct-track">
            <div class="pct-fill" :style="{ width: Math.min(resumo.percentual_ruptura_skus || 0, 100) + '%', background: '#ea580c' }"></div>
          </div>
          <span class="pct-hint">{{ formatNumber(resumo.qtd_skus_ruptura) }} de {{ formatNumber(resumo.qtd_skus_ativos) }} SKUs ativos</span>
        </div>
      </div>

      <div v-if="false" class="kpi-card kpi-card--pct">
        <div class="kpi-accent" style="background:#dc2626"></div>
        <div class="kpi-icon-wrap kpi-icon-wrap--sm" style="background:#fee2e2">
          <v-icon color="#b91c1c" size="18">mdi-currency-brl</v-icon>
        </div>
        <div class="kpi-body">
          <kpi-tooltip icon-size="10">
            <template v-slot:label>
              <span class="kpi-label">% Ruptura (R$)</span>
            </template>
            Impacto financeiro da ruptura: quanto representa o valor não atendido sobre a necessidade total de reabastecimento.
          </kpi-tooltip>
          <span class="kpi-value" style="color:#b91c1c">{{ formatPercent(resumo.percentual_ruptura_rs) }}</span>
          <div class="pct-track">
            <div class="pct-fill" :style="{ width: Math.min(resumo.percentual_ruptura_rs || 0, 100) + '%', background: '#dc2626' }"></div>
          </div>
          <span class="pct-hint">da necessidade</span>
        </div>
      </div>

      <div class="kpi-card kpi-card--pct">
        <div class="kpi-accent" style="background:#dc2626"></div>
        <div class="kpi-icon-wrap" style="background:#fee2e2">
          <v-icon color="#b91c1c" size="20">mdi-alert-outline</v-icon>
        </div>
        <div class="kpi-body">
          <kpi-tooltip>
            <template v-slot:label>
              <span class="kpi-label">Ruptura Total</span>
            </template>
            Valor total de produtos em ruptura, incluindo cortados por falta de estoque no CD, sugestões ignoradas e não atendimentos.
          </kpi-tooltip>
          <span class="kpi-value" style="color:#b91c1c">{{ formatCurrency(resumo.itens_em_rupturas) }}</span>
          <span class="kpi-skus">{{ formatNumber(resumo.qtd_skus_ruptura) }} SKUs em ruptura</span>
          <span v-if="percentualNaoAtendido > 0" class="kpi-percentual kpi-percentual-ruptura">
            {{ formatPercent(percentualNaoAtendido) }} da necessidade
          </span>
        </div>
      </div>

      <div class="kpi-card kpi-card--destaque" :class="{'kpi-card-alerta': destacaSemEstoque}">
        <div class="kpi-accent" style="background:#f97316"></div>
        <div class="kpi-icon-wrap" style="background:#ffedd5">
          <v-icon color="#ea580c" size="20">mdi-package-variant-remove</v-icon>
        </div>
        <div class="kpi-body">
          <kpi-tooltip>
            <template v-slot:label>
              <span class="kpi-label">Sem Estoque CD</span>
            </template>
            Valor de produtos cortados por falta de estoque no CD. Indica necessidade de compra ou transferência para o CD.
          </kpi-tooltip>
          <span class="kpi-value" style="color:#ea580c">{{ formatCurrency(resumo.necessidade_real_sem_estoque) }}</span>
          <span class="kpi-skus">{{ formatNumber(resumo.qtd_skus_sem_estoque) }} SKUs sem estoque</span>
          <span v-if="percentualSemEstoque > 0" class="kpi-percentual" :class="getClasseSemEstoque">
            {{ formatPercent(percentualSemEstoque) }} da ruptura total
          </span>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-accent" style="background:#f59e0b"></div>
        <div class="kpi-icon-wrap" style="background:#fef3c7">
          <v-icon color="#d97706" size="20">mdi-truck-remove-outline</v-icon>
        </div>
        <div class="kpi-body">
          <kpi-tooltip>
            <template v-slot:label>
              <span class="kpi-label">Não Atendidos</span>
            </template>
            Valor de produtos com pedidos de transferência criados, mas que não foram entregues às filiais, <strong>desconsiderando</strong> os itens cortados por falta de estoque no CD e sugestões ignoradas.
          </kpi-tooltip>
          <span class="kpi-value" style="color:#d97706">{{ formatCurrency(resumo.itens_nao_atendidos) }}</span>
          <span class="kpi-skus">{{ formatNumber(resumo.qtd_skus_nao_atendidos) }} SKUs não entregues</span>
          <span v-if="percentualNaoAtendidoLiquido > 0" class="kpi-percentual kpi-percentual-aviso">
            {{ formatPercent(percentualNaoAtendidoLiquido) }} da ruptura total
          </span>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-accent" style="background:#6b7280"></div>
        <div class="kpi-icon-wrap" style="background:#e5e7eb">
          <v-icon color="#4b5563" size="20">mdi-lightbulb-off-outline</v-icon>
        </div>
        <div class="kpi-body">
          <kpi-tooltip>
            <template v-slot:label>
              <span class="kpi-label">Sugestões Ignoradas</span>
            </template>
            Valor de produtos que o sistema sugeriu para reabastecimento, mas o comprador não criou pedido de transferência. Pode indicar decisão estratégica ou erro operacional.
          </kpi-tooltip>
          <span class="kpi-value" style="color:#4b5563">{{ formatCurrency(resumo.itens_sugestao_ignorada) }}</span>
          <span class="kpi-skus">{{ formatNumber(resumo.qtd_skus_ignorados) }} SKUs ignorados</span>
          <span v-if="percentualIgnorados > 0" class="kpi-percentual kpi-percentual-ignorado">
            {{ formatPercent(percentualIgnorados) }} da ruptura total
          </span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import KpiTooltip from './KpiTooltip.vue';

export default {
  name: 'RupturasResumo',

  components: {
    KpiTooltip
  },

  props: {
    resumo:  { type: Object, default: () => ({}) },
    periodo: { type: Object, default: () => ({}) },
    cache:   { type: Object, default: () => ({}) }
  },

  computed: {
    qtdSkusExcluidos() {
      const volume = this.resumo.qtd_skus_volume || 0;
      const ativos = this.resumo.qtd_skus_ativos || 0;
      return Math.max(0, volume - ativos);
    },

    percentualSemEstoque() {
      // MUDANÇA: Agora calcula sobre a RUPTURA TOTAL
      const ruptura = this.resumo.itens_em_rupturas || 0;
      const semEstoque = this.resumo.necessidade_real_sem_estoque || 0;
      if (ruptura === 0) return 0;
      return (semEstoque / ruptura) * 100;
    },

    percentualIgnorados() {
      // MUDANÇA: Agora calcula sobre a RUPTURA TOTAL
      const ruptura = this.resumo.itens_em_rupturas || 0;
      const ignorados = this.resumo.itens_sugestao_ignorada || 0;
      if (ruptura === 0) return 0;
      return (ignorados / ruptura) * 100;
    },

    percentualNaoAtendidoLiquido() {
      // MUDANÇA: Agora calcula sobre a RUPTURA TOTAL
      const ruptura = this.resumo.itens_em_rupturas || 0;
      const naoAtendidos = this.resumo.itens_nao_atendidos || 0;
      if (ruptura === 0) return 0;
      return (naoAtendidos / ruptura) * 100;
    },

    percentualExcluidos() {
      const total = this.resumo.total_volume || 0;
      const excluidos = this.resumo.total_excluidos || 0;
      if (total === 0) return 0;
      return (excluidos / total) * 100;
    },

    percentualNecessidade() {
      const total = this.resumo.total_volume || 0;
      const necessidade = this.resumo.necessidade_real || 0;
      if (total === 0) return 0;
      return (necessidade / total) * 100;
    },

    percentualAtendido() {
      const necessidade = this.resumo.necessidade_real || 0;
      const atendido = this.resumo.total_atendidos || 0;
      if (necessidade === 0) return 0;
      return (atendido / necessidade) * 100;
    },

    percentualNaoAtendido() {
      const necessidade = this.resumo.necessidade_real || 0;
      const naoAtendido = this.resumo.itens_em_rupturas || 0;
      if (necessidade === 0) return 0;
      return (naoAtendido / necessidade) * 100;
    },

    destacaSemEstoque() {
      return this.percentualSemEstoque > 30;
    },

    getClasseSemEstoque() {
      const pct = this.percentualSemEstoque;
      if (pct >= 50) return 'percentual-alto';
      // if (pct >= 50) return 'percentual-critico';
      if (pct >= 30) return 'percentual-alto';
      if (pct >= 10) return 'percentual-medio';
      return 'percentual-baixo';
    },

    alertaSemEstoqueCD() {
      return this.percentualSemEstoque > 30;
    },

    alertaRupturaCritica() {
      return (this.resumo.percentual_ruptura_skus || 0) > 50;
    }
  },

  methods: {
    formatCurrency(v) {
      if (v == null || isNaN(v)) return 'R$ 0,00';
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);
    },

    formatNumber(v) {
      if (v == null || isNaN(v)) return '0';
      return new Intl.NumberFormat('pt-BR').format(v);
    },

    formatPercent(v) {
      if (v == null || isNaN(v)) return '0,00%';
      return `${v.toFixed(2)}%`;
    }
  }
};
</script>

<style scoped>
.rupturas-resumo { display: flex; flex-direction: column; gap: 12px; }

.kpi-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.kpi-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 16px 16px 20px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(2,52,73,.04);
  overflow: hidden;
  transition: all .25s ease;
}

.kpi-card:hover {
  box-shadow: 0 4px 14px rgba(2,52,73,.09);
  transform: translateY(-1px);
}

.kpi-card--destaque {
  border-color: #fed7aa;
  background: linear-gradient(135deg, #fffbf5 0%, #fff 100%);
}

.kpi-card-alerta {
  border-color: #fb923c;
  background: linear-gradient(135deg, #fff7ed 0%, #fff 100%);
  box-shadow: 0 2px 8px rgba(249, 115, 22, 0.12);
}

.kpi-card-alerta:hover {
  box-shadow: 0 4px 16px rgba(249, 115, 22, 0.18);
}

.kpi-card--pct {
  border-color: #fed7aa;
  background: #fffbf5;
}

.kpi-accent {
  position: absolute; left: 0; top: 0; bottom: 0;
  width: 4px; border-radius: 12px 0 0 12px;
}

.kpi-icon-wrap {
  padding: 10px; border-radius: 10px;
  flex-shrink: 0; display: flex; align-items: center; justify-content: center;
}
.kpi-icon-wrap--sm { padding: 8px; border-radius: 8px; }

.kpi-body {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  flex: 1;
}

.kpi-label {
  font-size: .688rem; color: #94a3b8;
  font-weight: 700; text-transform: uppercase; letter-spacing: .5px; white-space: nowrap;
}

.kpi-value {
  font-size: 1rem; font-weight: 800; color: #023449;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis; line-height: 1.2;
}

.kpi-skus {
  font-size: .688rem;
  font-weight: 600;
  color: #64748b;
  line-height: 1.3;
  margin-top: 1px;
}

.kpi-percentual {
  font-size: .625rem;
  font-weight: 600;
  margin-top: 2px;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
  width: fit-content;
}

.percentual-critico { background: #fee2e2; color: #dc2626; }
.percentual-alto { background: #ffedd5; color: #ea580c; }
.percentual-medio { background: #fef3c7; color: #d97706; }
.percentual-baixo { background: #dcfce7; color: #16a34a; }
.kpi-percentual-ok { background: #d1fae5; color: #047857; }
.kpi-percentual-aviso { background: #fef3c7; color: #d97706; }
.kpi-percentual-ruptura { background: #fee2e2; color: #dc2626; }
.kpi-percentual-neutro { background: #f1f5f9; color: #64748b; }
.kpi-percentual-info { background: #e0f4f8; color: #023449; }
.kpi-percentual-ignorado { background: #e5e7eb; color: #4b5563; }

.pct-track {
  height: 4px; background: #f1f5f9;
  border-radius: 3px; margin-top: 5px; overflow: hidden;
}
.pct-fill { height: 100%; border-radius: 3px; transition: width .4s ease; }
.pct-hint { font-size: .625rem; color: #94a3b8; font-weight: 500; margin-top: 1px; }


@media (max-width: 900px) {
  .kpi-row { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 600px) {
  .kpi-row { grid-template-columns: 1fr; }
}
</style>